import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pol-loader',
  templateUrl: './pol-loader.component.html',
  styleUrls: ['./pol-loader.component.scss']
})
export class PolLoaderComponent implements OnInit {

  @Input() skeletonSize: 'small' | 'medium' | 'large' = 'medium';
  @Input() skeletonStyle: 'padding' | 'none' = 'padding';
  @Input() skeletonType: 'text' | 'image'  = 'text';
  @Input() skeletonTitle: boolean = false;
  @Input() skeletonFooter: boolean = false;
  @Input() skeletonRows: number = 3;
  @Input() skeletonAlignment: 'staggered' | 'aligned' | 'table-aligned' = 'staggered'
  
  constructor() {}
  ngOnInit(): void {}

  get rows() {
    return Array(this.skeletonRows).fill(0);
  }
}
